import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiConfig from "../axiosConfig";

const initialState = {
	recommendationList: [],
	labels: [],
	status: null,
	error: null,
};

export const getAllRecommendation = createAsyncThunk("recommendation/fetch", async ({ countryCode }) => {
	if (countryCode == null) countryCode = 'my';
	const response = await apiConfig
		.get(`recommendation/list/${countryCode}/1`)
		.then((response) => response)
		.catch((error) => error);

	return response.data;
});

export const addRecommendation = createAsyncThunk("recommendation/add", async (payload) => {
	let addPayload = { ...payload };
	const response = await apiConfig
		.post(`recommendation/create`, { ...addPayload })
		.then((response) => response)
		.catch((error) => error);

	const data = (await response) && response.data ? response.data : response;
	return { ...data };
});

export const updateRecommendation = createAsyncThunk("recommendation/update", async (payload) => {
	let updatePayload = { ...payload };

	const response = await apiConfig
		.post(`recommendation/update/${payload.id}`, { ...updatePayload })
		.then((response) => response)
		.catch((error) => error);

	const data = (await response) && response.data ? response.data : response;
	return { ...data };
});

export const deleteRecommendation = createAsyncThunk("recommendation/update/isDelete", async ({ receommendationId }) => {
	const response = await apiConfig
		.put(`recommendation/updateDelete/${receommendationId}`)
		.then((response) => response)
		.catch((error) => error);

	const data = (await response) && response.data ? response.data : response;
	return { ...data, receommendationId };
});

const recommendationSlice = createSlice({
	name: "recommendation",
	initialState,
	reducers: {},
	extraReducers: {
		[getAllRecommendation.pending]: (state) => {
			state.status = "loading";
		},
		[getAllRecommendation.fulfilled]: (state, action) => {
			const response = action.payload.data;
			if (response && action.payload.status === "OK") {
				state.recommendationList = [];
				state.status = "OK";
				state.recommendationList = response.sections.recommendations;
				state.labels = response.sections.labels;
			} else {
				state.status = "failed";
				state.recommendationList = [];
				state.labels = [];
				state.error = action?.error?.message || action?.payload?.message;
			}
		},
		[getAllRecommendation.rejected]: (state, action) => {
			state.status = "failed";
			state.error = action.error.message;
		},
		[addRecommendation.fulfilled]: (state, action) => {
			const response = action.payload;
			if (response.status === "CREATED") {
				const itemIndex = state.recommendationList.findIndex((item) => item.id === action.payload.data.id);
				if (itemIndex === -1) {
					state.recommendationList = [...state.recommendationList, action.payload.data];
				} else {
					state.recommendationList[itemIndex] = action.payload.data;
				}
			} else {
				state.status = "failed";
				state.error = action.message;
			}
		},
		[updateRecommendation.fulfilled]: (state, action) => {
			const response = action.payload;
			if (response.status === "Ok") {
				const itemIndex = state.recommendationList.findIndex((item) => item.id === action.payload.data.id);
				if (itemIndex === -1) {
					state.recommendationList = [...state.recommendationList, action.payload.data];
				} else {
					state.recommendationList[itemIndex] = action.payload.data;
				}
			} else {
				state.status = "failed";
				state.error = action.message;
			}
		},
		[deleteRecommendation.fulfilled]: (state, action) => {
			const response = action.payload;

			if (response.status === "ACCEPTED") {
				const itemIndex = state.recommendationList.findIndex((item) => item.id === response.receommendationId);
				if (itemIndex !== -1) {
					state.recommendationList[itemIndex].isDeleted = !state.recommendationList[itemIndex].isDeleted;
				}
			} else {
				state.status = "failed";
				state.error = action?.error?.message || "";
			}
		},
	},
});

export const assetManagementActions = recommendationSlice.actions;
export default recommendationSlice.reducer;
